var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"brand-wrapper"},[_c('div',{staticClass:"brand-image"},[_c('img',{attrs:{"src":_vm.image,"alt":_vm.brand.name}})]),_c('div',{staticClass:"brand-name"},[_vm._v(_vm._s(_vm.brand.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }